/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-undef */
import React, { useState, useContext, useEffect, useCallback } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { isMobile } from "react-device-detect";
import { popupWin } from "components/PopUps";

import { useNavigate } from "react-router-dom";
import {
  StepBody,
  Spinner,
  Line,
  Row,
  ButtonNext,
  ButtonPrev,
  InnerMedium,
  useInput,
  Icon,
  Button,
  Between,
  Stepper_Uikit,
} from "meitav-uikit";

import {
  UmbracoContext,
  UmbracoStep,
  UmbracoChildren,
  UmbracoStepChildren,
  UmbracoUpStep,
} from "../../../components/Umbraco/UmbracoContext";
import utils from "../../../utils";

import Question0 from "./Question0";
import Question1 from "./Question1";
import Question2 from "./Question2";
import Question8 from "./Question8";
import QuestionAll from "./QuestionAll";

const { UmbracoUtills, rest } = utils;

export default function FillingQuestions() {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const addStartupScripts = () => {
    const script = document.createElement("script");
    script.append(`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-KZFXLQC');`);
    document.head.appendChild(script);

    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");
    iframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-KZFXLQC";
    iframe.height = "0";
    iframe.width = "0";
    iframe.style = "display:none;visibility:hidden";
    noscript.appendChild(iframe);
    document.body.appendChild(noscript);
    //MANJOIN-697
    localStorage.removeItem("Disabled");
  };
  const resourceIcon = UmbracoStep(
    useContext(UmbracoContext).resource,
    "Question0"
  );
  const Contradictions = UmbracoStep(
    useContext(UmbracoContext).resource,
    "Contradictions"
  );

  const resourceUpContact = UmbracoStep(
    useContext(UmbracoContext).resource,
    "PopUpContactUS"
  );
  const CalculationOfRiskLevel = UmbracoStep(
    useContext(UmbracoContext).resource,
    "CalculationOfRiskLevel"
  );
  const [questions, setOuestions] = useState({
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
    6: "",
    7: "",
    8: "",
  });
  const [scores, setScores] = useState({
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
    6: "",
    7: "",
  });
  const [joinInvestPolicyTempData, setJoinInvestPolicyTemp] = useState([]);
  const stepsSub = [0, 1, 2, 3, 4, 5, 6];
  const [stepActive, setStepActive] = useState(-1);
  const [joinInvestPolicyTempID, setJoinInvestPolicyTempID] = useState(0);
  const [nextDisabled, setNextDisabled] = useState(true);
  //const [nextDisabledcss, setNextDisabledcss] = useState("");
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const [contradictionText, setContradictionText] = useState("");
  const [contradictionButton, setContradictionButton] = useState("");
  const [openSpinner, setOpenSpinner] = useState(true);
  const [riskLevel, setRiskLevel] = useState(0);
  const [popupObj, setPopupObj] = useState("");
  const handleReCaptchaVerify = async (actionName) => {
    if (!executeRecaptcha) {
      return false;
    }
    const token = await executeRecaptcha(actionName);
    return token;
  };
  const handleCickContactUs = () => {
    let obj = {};
    obj.type = "contactUs";
    obj.resource = resourceUpContact;
    obj.className = "contactUs";

    popupWin(obj);
  };
  const checkGuidasUrl = async () => {
    const guid = localStorage.getItem("investPolicyGUID");

    if (guid != null) {
      const token = await handleReCaptchaVerify(`checkGuidasUrl`);
      await rest
        .get(`/api/Manager/CheckGuidJoinInvestPolicyTemp?guid=${guid}`, {
          headers: {
            gCaptcha: token,
            action: "checkGuidasUrl",
          },
        })
        .then(async (res) => {
          if (!res.data) {
            try {
              await newJoinInvestPolicyTemp();
            } catch (ex) {
              console.log("error checkGuidasUrl line140: " + ex);
            }
          } else {
            localStorage.setItem("investPolicyGUID", guid);
            //setNextDisabled(false);
            //setNextDisabledcss("");

            const getJoinInvestPolicyTemptoken = await handleReCaptchaVerify(
              `getJoinInvestPolicyTemp`
            );

            await rest
              .get(`/api/Manager/GetJoinInvestPolicyTemp?guid=${guid}`, {
                headers: {
                  gCaptcha: getJoinInvestPolicyTemptoken,
                  action: "getJoinInvestPolicyTemp",
                },
              })
              .then((res) => {
                setJoinInvestPolicyTemp(res.data);
              });
          }
        })
        .catch((error) => {
          console.log("error checkGuidasUrl line164: " + ex);
        });
    } else {
      await newJoinInvestPolicyTemp();
    }
  };

  const newJoinInvestPolicyTemp = async () => {
    localStorage.setItem("investPolicyGUID", "");
    localStorage.clear();
    const newJoinInvestPolicyTemptoken = await handleReCaptchaVerify(
      `newJoinInvestPolicyTemp`
    );

    await rest
      .get(`/api/Manager/NewJoinInvestPolicyTemp`, {
        headers: {
          gCaptcha: newJoinInvestPolicyTemptoken,
          action: "newJoinInvestPolicyTemp",
        },
      })
      .then((res) => {
        localStorage.setItem("investPolicyGUID", res?.data);

        //setNextDisabled(false);
        //setNextDisabledcss("");
      });
  };

  const showChatCommbox = UmbracoUtills.getValueByKey(
    resourceIcon,
    "showChatCommbox"
  );
  if (showChatCommbox === "True" && !document.getElementById("connectScript")) {
    const script = document.createElement("script");
    script.id = "connectScript";
    script.type = "text/javascript";
    script.src = "//apps.commbox.io//Scripts/connect.js";
    script.onload = () => {
      if (window.BY) {
        window.BY.chat({
          baseDomain: "commbox.io/",
          appsSubDomain: "apps",
          streamId: "pEs3A48EEgBZq_f07v29YQw%3d%3d",
          trackerStreamId: "6E72AsLXk6gLVtWt61Lo9A%3d%3d",
        });
      }
    };
    document.head.appendChild(script);
  }

  const changeAnswer = (setQuestion, valItem, valScore, valueText) => {
    setOuestions({
      ...questions,
      [setQuestion]: valItem,
    });
    setScores({
      ...scores,
      [setQuestion]: valScore,
    });
    setNextDisabled(false);
    // setNextDisabledcss("");
    if (
      (setQuestion == 1 &&
        (valItem < 25000 || valItem > 1000000 || valItem == 0)) ||
      (setQuestion == 2 && (valItem < 18 || valItem > 120))
    ) {
      setNextDisabled(true);
      //setNextDisabledcss("nextDisabledcss");
    }
    if (setQuestion != 1 && setQuestion != 2)
      setDataLayerValue(setQuestion, valItem, valueText);
  };
  const CloseContradiction = (value) => {
    setStepActive(4);
  };
  let navigate = useNavigate();

  const next = async () => {
    if (stepActive === -1) {
      setStepActive((prevActiveStep) => prevActiveStep + 1);
      return;
    }
    setNextDisabled(true);
    // setNextDisabledcss("nextDisabledcss");
    try {
      setDataLayer();
      let check = false;
      if (stepActive > 3) check = await checkContradiction();
      if (!check) {
        const sav = await saveJoinInvestPolicyTemp();
        if (!sav) {
          console.log("saveJoinInvestPolicyTemp error");
          return;
        }
        //}

        if (stepActive == 6) {
          const p = await saveCalculationOfRiskLevel();
          setRiskLevel(p);
        }
        if (stepActive == 7) {
          const p2 = await saveSectorType();
          navigate("../PleaseWait", { replace: true });
        }
        // setNextDisabled(false);
        // setNextDisabledcss("");
        setStepActive((prevActiveStep) => prevActiveStep + 1);
      }
    } catch (ex) {
      console.log("error next line262: " + ex);
      next();
    }
  };
  const setDataLayer = () => {
    switch (stepActive + 1) {
      case 0:
        window.dataLayer.push({
          event: "PM - explain screen",
          eventInfo: {
            action_screen: window.location.pathname,
            process_level: "הסבר",
            action_name: "המשך מוצלח של שלב הסבר",
          },
        });
        break;
      case 1:
        window.dataLayer.push({
          event: "PM - needs",
          eventInfo: {
            action_screen: window.location.pathname,
            user_investment_value: questions[1],
            process_level: "סכום ההשקעה הראשוני",
            action_name: "המשך מוצלח של שלב סכום ההשקעה הראשוני",
            investment_value_metric: questions[1],
          },
        });
        break;
      case 2:
        window.dataLayer.push({
          event: "PM - private details",
          eventInfo: {
            action_screen: window.location.pathname,
            process_level: "פרטים אישיים",
            action_name: "המשך מוצלח של שלב פרטים אישיים",
          },
        });
        break;
      case 3:
        const a = `המשך מוצלח של שלב נכסים נזילים`;
        window.dataLayer.push({
          event: "PM - needs",
          eventInfo: {
            action_screen: window.location.pathname,
            process_level: "נכסים נזילים",
            action_name: a,
          },
        });
        break;
      case 4:
        window.dataLayer.push({
          event: "PM - needs",
          eventInfo: {
            action_screen: window.location.pathname,
            process_level: "משך השקעה",
            action_name: "המשך מוצלח של שלב - מתי אצטרך את הכסף שאחסוך",
          },
        });
        break;
      case 5:
        window.dataLayer.push({
          event: "PM - needs",
          eventInfo: {
            action_screen: window.location.pathname,
            process_level: "הגדרת סיכונים",
            action_name:
              "המשך מוצלח של שלב - אם שווי התיק שלך היה נופל ב – 10% תוך שבוע, איך היית מרגיש",
          },
        });
        break;
      case 6:
        window.dataLayer.push({
          event: "PM - needs",
          eventInfo: {
            action_screen: window.location.pathname,
            process_level: "הגדרת סיכונים",
            action_name:
              'המשך מוצלח של שלב -אם היה לך תיק השקעות בשווי 100,000 ש"ח ובתוך שבוע השווי היה יורד',
          },
        });
        break;
      case 7:
        window.dataLayer.push({
          event: "PM - needs",
          eventInfo: {
            action_screen: window.location.pathname,
            process_level: "הגדרת רמת סיכון",
            action_name:
              "המשך מוצלח של שלב הגדרת רמת סיכון שארצה לקחת בהשקעות שלי",
          },
        });
        break;
      case 8:
        return window.dataLayer.push({
          event: "PM - sector",
          eventInfo: {
            action_screen: window.location.pathname,
            process_level: "בחירת אפיק השקעה",
            action_name: "המשך מוצלח של שלב אפיק השקעה",
          },
        });
        break;
      default:
        break;
    }
  };
  const setDataLayerValue = (setQuestion, valItem, valueText) => {
    switch (setQuestion) {
      case 1:
        const action_name1 = `סכום ראשוני להפקדה - ${valItem} `;
        return window.dataLayer.push({
          event: "PM - needs",
          eventInfo: {
            action_screen: window.location.pathname,
            process_level: "סכום ההשקעה הראשוני",
            action_name: action_name1,
          },
        });
      case 2:
        const action_name2 = `${valItem} גיל בשנים `;
        return window.dataLayer.push({
          event: "PM - private details",
          eventInfo: {
            action_screen: window.location.pathname,
            user_age: `${valItem}`,
            process_level: "פרטים אישיים",
            action_name: action_name2,
          },
        });
      case 3:
        const action_name3 = `הכסף שאשקיע הוא ${valueText} מהנכסים הנזילים שלי`;
        return window.dataLayer.push({
          event: "PM - needs",
          eventInfo: {
            action_screen: window.location.pathname,
            process_level: "נכסים נזילים",
            action_name: action_name3,
          },
        });
      case 4:
        const action_name4 = `נראה לי שאצטרך את הכסף עוד ${valueText}`;
        return window.dataLayer.push({
          event: "PM - needs",
          eventInfo: {
            action_screen: window.location.pathname,
            process_level: "משך השקעה",
            action_name: action_name4,
          },
        });
      case 5:
        const action_name5 = `אם שווי התיק שלך היה נופל בתוך שבוע - ${valueText}`;
        return window.dataLayer.push({
          event: "PM - needs",
          eventInfo: {
            action_screen: window.location.pathname,
            process_level: "הגדרת סיכונים",
            action_name: action_name5,
          },
        });
      case 6:
        const action_name6 = `אם היה לך תיק השקעות בשווי 100,000 שח ובתוך שבוע השווי היה יורד ל 90,000 סביר שהייתי ${valueText}`;
        return window.dataLayer.push({
          event: "PM - needs",
          eventInfo: {
            action_screen: window.location.pathname,
            process_level: "הגדרת סיכונים",
            action_name: action_name6,
          },
        });
      case 7:
        const action_name7 = `הגדרת רמת סיכון שארצה לקחת בהשקעות שלי- ${valueText}`;
        return window.dataLayer.push({
          event: "PM - needs",
          eventInfo: {
            action_screen: window.location.pathname,
            process_level: "הגדרת רמת סיכון",
            action_name: action_name7,
          },
        });
      case 8:
        const action_name8 = `אפיק ההשקעות שבחרתי- ${valueText}`;
        return window.dataLayer.push({
          event: "PM - sector",
          eventInfo: {
            action_screen: window.location.pathname,
            process_level: "בחירת אפיק השקעה",
            action_name: action_name8,
          },
        });
      default:
        break;
    }
  };
  const previous = () => {
    setStepActive((prevActiveStep) => prevActiveStep - 1);
    setNextDisabled(false);
    // setNextDisabled(true);

    // setNextDisabledcss("");
    window.dataLayer.push({
      event: "PM - Levels",
      eventInfo: {
        action_screen: "/CustomerInvestPolicy",
        process_level: "חזור לשלב הקודם",
        action_name: "חזרה - " + stepActive,
      },
    });
  };
  const saveJoinInvestPolicyTemp = async () => {
    const guid = localStorage.getItem("investPolicyGUID");
    const question = stepActive + 1;
    const answer =
      questions[`${question}`] !== undefined ? questions[`${question}`] : 0;

    const SaveJoinInvestPolicyTemptoken = await handleReCaptchaVerify(
      `SaveJoinInvestPolicyTemp${question}`
    );
    let ans = false;
    try {
      await rest
        .get(
          `/api/Manager/SaveJoinInvestPolicyTemp?guid=${guid}&question=${question}&answer=${answer}`,
          {
            headers: {
              gCaptcha: SaveJoinInvestPolicyTemptoken,
              action: `SaveJoinInvestPolicyTemp${question}`,
            },
          }
        )
        .then((res) => {
          setJoinInvestPolicyTempID(res?.data);
          if (res?.data > -1) {
            ans = true;
          }
        });
    } catch (ex) {
      console.log("error saveJoinInvestPolicyTemp line 495: " + ex);
      return ans;
    }

    if (!ans) {
      window.location.href = "/CustomerInvestPolicy";
      return ans;
    }
    return ans;
  };

  const saveContradiction = async () => {
    try {
      const guid = localStorage.getItem("investPolicyGUID");

      const question = stepActive + 1;
      const answer =
        questions[`${question}`] != undefined ? questions[`${question}`] : 0;

      const SaveContradictiontoken = await handleReCaptchaVerify(
        `SaveContradiction`
      );

      await rest
        .get(
          `/api/Manager/SaveContradiction?guid=${guid}&question=${question}&answer=${answer}`,
          {
            headers: {
              gCaptcha: SaveContradictiontoken,
              action: "SaveContradiction",
            },
          }
        )
        .then((res) => {
          setJoinInvestPolicyTempID(res?.data);
          return;
        });
    } catch (ex) {
      console.log("error saveContradiction 539: " + ex);
    }
  };
  const checkContradiction = async () => {
    try {
      const question = stepActive + 1;
      let contradictionText = "";
      let contradictionTextVal = "";
      let contradictionOk = UmbracoUtills.getValueByKey(
        Contradictions,
        "contradictionOk"
      );
      setContradictionButton(contradictionOk);
      if (question == 6) {
        if (questions[5] == "1" && questions[question] == "4") {
          contradictionText = UmbracoUtills.getValueByKey(
            Contradictions,
            "contradiction1"
          );
          contradictionTextVal = UmbracoUtills.getValueByKey(
            Contradictions,
            "contradiction1Text"
          );
          setContradictionText(contradictionText);
          await contradictionOpen(
            question,
            `${contradictionTextVal}- סתירה 1`,
            contradictionText,
            contradictionOk
          );
          return true;
        }
        if (
          (questions[5] == "3" || questions[5] == "4") &&
          (questions[question] == "2" || questions[question] == "1")
        ) {
          contradictionText = UmbracoUtills.getValueByKey(
            Contradictions,
            "contradiction2"
          );
          contradictionTextVal = UmbracoUtills.getValueByKey(
            Contradictions,
            "contradiction2Text"
          );
          setContradictionText(contradictionText);
          await contradictionOpen(
            question,
            `${contradictionTextVal}- סתירה 2`,
            contradictionText,
            contradictionOk
          );

          return true;
        }
      }
      if (
        question == 7 &&
        (questions[6] == "1" || questions[6] == "2") &&
        (questions[question] == "3" || questions[question] == "4")
      ) {
        contradictionText = UmbracoUtills.getValueByKey(
          Contradictions,
          "contradiction3"
        );
        contradictionTextVal = UmbracoUtills.getValueByKey(
          Contradictions,
          "contradiction3Text"
        );
        setContradictionText(contradictionText);
        await contradictionOpen(
          question,
          `${contradictionTextVal}- סתירה 3`,
          contradictionText,
          contradictionOk
        );

        return true;
      } else return false;
    } catch (ex) {
      console.log("error checkContradiction 603: " + ex);
      return false;
    }
  };
  const contradictionOpen = async (
    question,
    contradictionMessage,
    contradictionText,
    contradictionButton
  ) => {
    try {
      const processLevel = question;
      const actionName = `סתירה לוגית - ${contradictionText} - ${contradictionMessage}`;
      window.dataLayer.push({
        event: "PM - Errors",
        eventInfo: {
          action_screen: window.location.pathname,
          process_level: processLevel,
          action_name: actionName,
        },
      });

      setContradictionButton(
        UmbracoUtills.getValueByKey(Contradictions, "contradictionOk")
      );
      let obj = {};
      obj.type = "contradiction";
      obj.handleClose = CloseContradiction;
      obj.contradictionText = contradictionText;
      obj.contradictionButton = contradictionButton;
      popupWin(obj);
      await saveJoinInvestPolicyTemp();
      await saveContradiction();
    } catch (ex) {
      console.log("error contradictionOpen 633: " + ex);
      return false;
    }
  };
  const saveCalculationOfRiskLevel = async () => {
    const guid = localStorage.getItem("investPolicyGUID");

    const data = {
      joinInvestPolicyTempGuid: guid,
      Score1: scores[2],
      Score2: scores[3],
      Score3: scores[4],
      Score4: scores[5],
      Score5: scores[6],
      Score6: scores[7],
      Answer1: questions[3],
      Answer2: questions[4],
      Answer3: questions[5],
      Answer4: questions[6],
      Answer5: questions[7],
      RiskLevel1: UmbracoUtills.getValueByKey(
        CalculationOfRiskLevel,
        "riskLevelpart1"
      ),
      RiskLevel2: UmbracoUtills.getValueByKey(
        CalculationOfRiskLevel,
        "riskLevelpart2"
      ),
      RiskLevel3: UmbracoUtills.getValueByKey(
        CalculationOfRiskLevel,
        "riskLevelpart3"
      ),
      RiskLevel4: UmbracoUtills.getValueByKey(
        CalculationOfRiskLevel,
        "riskLevelpart4"
      ),
    };

    window.dataLayer.push({
      event: "PM - needs",
      eventInfo: {
        action_screen: window.location.pathname,
        process_level: "הגדרת רמת סיכון",
        action_name: "המשך מוצלח של שלב הגדרת רמת סיכון שארצה לקחת בהשקעות שלי",
      },
    });

    const data1 = JSON.stringify(data);

    const SaveCalculationOfRiskLeveltoken = await handleReCaptchaVerify(
      `SaveCalculationOfRiskLevel`
    );

    const ans = await rest.get(
      `/api/Manager/SaveCalculationOfRiskLevel?data=${data1}`,
      {
        headers: {
          gCaptcha: SaveCalculationOfRiskLeveltoken,
          action: "SaveCalculationOfRiskLevel",
        },
      }
    );
    return ans.data;
  };

  const saveSectorType = async () => {
    try {
      const guid = localStorage.getItem("investPolicyGUID");

      const data = {
        joinInvestPolicyTempGuid: guid,
        sectorCode: questions[8],
      };

      const data1 = JSON.stringify(data);

      const SaveSectorTypetoken = await handleReCaptchaVerify(
        `SaveSectorTypetoken`
      );

      const ans = await rest.get(`/api/Manager/SaveSectorType?data=${data1}`, {
        headers: {
          gCaptcha: SaveSectorTypetoken,
          action: "SaveSectorType",
        },
      });
    } catch (ex) {
      console.log("error saveSectorType 724: " + ex);
      return false;
    }
    return true;
  };

  useEffect(() => {
    addStartupScripts();
  }, []);

  useEffect(() => {
    const isCaptchaReady = executeRecaptcha ? true : false;
    if (isCaptchaReady) {
      (async () => {
        try {
          await checkGuidasUrl();
          setOpenSpinner(false);
          const search = window.location.search;
          const params = new URLSearchParams(search);
          const utm_source = params.get("utm_source");
          const utm_medium = params.get("utm_medium");
          localStorage.removeItem("utm_source");
          localStorage.removeItem("utm_medium");

          if (utm_source != null)
            localStorage.setItem("utm_source", utm_source);

          if (utm_medium != null)
            localStorage.setItem("utm_medium", utm_medium);
        } catch (error) {
          console.log("error line730: " + ex);
        }
      })();
    }
  }, [executeRecaptcha]);

  return (
    <>
      {!openSpinner ? (
        <div>
          <div className="sr-only">לפניך תהליך בין 7 שלבים</div>
          <div className="sr-only">שלב {stepActive + 1} מתוך 7</div>
          <>
            <Line className="stepper">
              <Stepper_Uikit
                activeStep={stepActive}
                steps={stepsSub}
                color="green"
              ></Stepper_Uikit>
            </Line>
            <InnerMedium className="innerCustomer">
              <Row type="large">
                <StepBody site="manager">
                  {getStepContent(
                    stepActive,

                    setNextDisabled,
                    resourceIcon,
                    changeAnswer,
                    questions,
                    riskLevel,
                    joinInvestPolicyTempData
                    //answer
                  )}
                </StepBody>
                <div className="stepFooter">
                  <Between>
                    {stepActive > -1 && stepActive < 7 ? (
                      <ButtonPrev
                        variant="none"
                        onClick={previous}
                      ></ButtonPrev>
                    ) : (
                      <div></div>
                    )}
                    <div className="leftFooter">
                      <ButtonNext
                        className={`${nextDisabled ? "nextDisabledcss" : ""}`}
                        onClick={next}
                        disabled={nextDisabled}
                        text={"המשך"}
                      ></ButtonNext>
                      {/*  <Button
                        className="callMeBack"
                        variant="none"
                        onClick={handleCickContactUs}
                        text={"תחזרו אלי"}>
                      </Button>*/}
                    </div>
                  </Between>
                </div>
              </Row>
            </InnerMedium>
          </>
        </div>
      ) : (
        <Spinner />
      )}
    </>
  );
}

function getStepContent(
  stepIndex,
  setNextDisabled,
  resourceIcon,
  changeAnswer,
  questions,
  riskLevel,

  joinInvestPolicyTempData
  // answer
) {
  const stepActive = stepIndex + 1;
  const changeAnswerFunc = (activeStep, valItem, valScore, valueText) => {
    changeAnswer(activeStep, valItem, valScore, valueText);
  };

  const question = `question${stepActive}`;

  let answerSet = "";
  if (joinInvestPolicyTempData != "" && questions[stepActive] == "") {
    answerSet = joinInvestPolicyTempData[question];
  } else {
    answerSet = questions[stepActive];
  }
  switch (stepIndex) {
    case -1:
      return <Question0 setNextDisabled={setNextDisabled} />;
    case 0:
      return (
        <Question1
          setNextDisabled={setNextDisabled}
          questions={questions}
          resourceIcon={resourceIcon}
          stepActive={stepActive}
          changeAnswerFunc={changeAnswerFunc}
          anserOld={answerSet != "" ? answerSet : 25000}
        />
      );
    case 1:
      return (
        <Question2
          setNextDisabled={setNextDisabled}
          resourceIcon={resourceIcon}
          stepActive={stepActive}
          changeAnswerFunc={changeAnswerFunc}
          anserOld={answerSet != "" ? answerSet : 18}
        />
      );
    case 2:
    case 3:
    case 4:
    case 5:
    case 6:
      return (
        <QuestionAll
          // answer={answer}
          setNextDisabled={setNextDisabled}
          resourceIcon={resourceIcon}
          stepActive={stepActive}
          changeAnswerFunc={changeAnswerFunc}
          anserOld={answerSet != "" ? answerSet : 0}
          questions={questions}
        />
      );
    case 7:
      return (
        <Question8
          setNextDisabled={setNextDisabled}
          resourceIcon={resourceIcon}
          stepActive={stepActive}
          changeAnswerFunc={changeAnswerFunc}
          anserOld={answerSet != "" ? answerSet : 0}
          riskLevel={riskLevel}
        />
      );
    default:
      return null;
  }
}
